<script>
import { mapGetters } from 'vuex';
import googleCalendarAPI from '../../../../api/googleCalendar';
import Spinner from 'shared/components/Spinner.vue';

export default {
  components: {
    Spinner,
  },
  computed: {
    ...mapGetters({ accountId: 'getCurrentAccountId' }),
  },
  mounted() {
    this.handleCallback();
  },
  methods: {
    async handleCallback() {
      const code = this.$route.query.code;

      if (!code) {
        this.redirectToSettings();
        return;
      }

      try {
        await googleCalendarAPI.callback(code);

        // Notify parent window
        if (window.opener) {
          window.opener.postMessage(
            { type: 'google-calendar-connected' },
            window.location.origin
          );
          window.close();
        } else {
          // If no opener, redirect to settings
          this.redirectToSettings();
        }
      } catch (error) {
        console.error('OAuth callback error:', error);
        this.redirectToSettings();
      }
    },

    redirectToSettings() {
      this.$router.push({
        name: 'settings_integrations',
        params: { accountId: this.accountId },
      });
    },
  },
};
</script>

<template>
  <div class="flex items-center justify-center min-h-screen">
    <div class="text-center">
      <Spinner size="large" />
      <p class="mt-4 text-slate-600">Conectando ao Google Calendar...</p>
    </div>
  </div>
</template>
